<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
  >
    <v-form class="mt-5">
      <v-text-field
        v-bind:label="$t('Integrator')"
        v-model="integrator"
        maxlength="100"
        :counter="100"
        :error-messages="integratorErrors"
        @input="$v.integrator.$touch()"
        @blur="$v.integrator.$touch()"
      ></v-text-field>
      <v-text-field
        v-bind:label="$t('Organization')"
        v-model="organization"
        maxlength="100"
        :counter="100"
        :error-messages="organizationErrors"
        @input="$v.organization.$touch()"
        @blur="$v.organization.$touch()"
      ></v-text-field>
    </v-form>
  </base-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import Utils from "@/ecm/common/Utils";
import LicenceService from "@/services/LicenceService";

export default {
  name: "LicenceModal",
  data() {
    return {
      modal: {
        title: this.$t("Licence"),
        key: "licenceModal",
      },
      open: false,
      integrator: "",
      organization: "",
    };
  },
  mixins: [validationMixin],
  validations: {
    integrator: { required },
    organization: { required },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    modalTitle() {
      return this.modal.title;
    },
    integratorErrors() {
      const errors = [];
      if (!this.$v.integrator.$dirty) return errors;
      !this.$v.integrator.required && errors.push(this.$t("RequiredField"));
      return errors;
    },
    organizationErrors() {
      const errors = [];
      if (!this.$v.organization.$dirty) return errors;
      !this.$v.organization.required && errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    saveItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.modalInstance.progress(true);

      LicenceService.request({
        Organization: this.organization,
        Integrator: this.integrator,
      })
        .then((result) => {
          if (result) {
            Utils.toast.success(this.$t("License") + " " + this.$t("CreatedSuccessfully"));
            this.hide();
            this.$emit("on-item-saved");
          }
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    new() {
      this.integrator = "";
      this.organization = "";
      this.$v.$reset();
      this.show();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>